import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] text-brand-muted text-center py-8 px-6 text-[12px] leading-[2]" data-id="element-175">
      <p className="font-display text-[14px] text-white/60 mb-2 tracking-[1px] uppercase" data-id="element-176">
        🌿 MEGAPACK CUERPO NUEVO DESPUÉS DE LOS 40™
      </p>
      <p data-id="element-177">
        El sistema de alimentación metabólica N°1 para mujeres que quieren
        adelgazar,
        <br data-id="element-178" />
        desinflamarse y recuperar su energía en la menopausia.
      </p>
      <p className="mt-2.5" data-id="element-179">
        <a href="mailto:soporte@impulsodigitalstore.com" className="text-white/70 hover:text-brand-green transition-colors" data-id="element-180">
          soporte@impulsodigitalstore.com
        </a>
        &nbsp;·&nbsp;
        <a href="#" className="text-white/70 hover:text-brand-green transition-colors" data-id="element-181">
          @impulsodigital.store
        </a>
        &nbsp;·&nbsp;
        <a href="https://www.impulsodigitalstore.com" className="text-white/70 hover:text-brand-green transition-colors" data-id="element-182">
          www.impulsodigitalstore.com
        </a>
      </p>
      <p className="mt-2.5" data-id="element-183">
        <a href="#" className="text-white/70 hover:text-brand-green transition-colors" data-id="element-184">
          Términos y condiciones
        </a>{' '}
        ·{' '}
        <a href="#" className="text-white/70 hover:text-brand-green transition-colors" data-id="element-185">
          Política de privacidad
        </a>
      </p>
      <p className="mt-2.5" data-id="element-186">
        © 2026 MegaPack Cuerpo Nuevo después de los 40™ — Todos los derechos
        reservados.
        <br data-id="element-187" />
        Este producto es digital. No se envía ningún producto físico por correo.
      </p>
      <p className="mt-2 italic" data-id="element-188">
        Este sitio no forma parte de Facebook ni de Facebook Inc.
      </p>
    </footer>;
}